import { useMemo } from "react";
import { CourseMaterial, useCoursesLoaderData } from "./coursesLoader";
import useTermOptDeadline from "./useTermOptDeadline";
import useFindCourse from "./useFindCourse";

// This hook determines the opt-out deadline for a specific course material based on the course ID.
// If you don't have a course ID need probably need the opt-out deadline for the current term.
// In this case use the `useTermOptDeadline` hook instead.
export default function useMaterialOptDeadline({ courseId }: CourseMaterial) {
  const { currentTerm } = useCoursesLoaderData();
  const { optDeadline: termOptDeadline, optWindowOpen: termOptWindowOpen } =
    useTermOptDeadline();
  const course = useFindCourse({ courseId });
  const isIA = currentTerm?.institutionProgram === "inclusive_access";
  const deadlineDate = course?.optOutDeadline
    ? new Date(course.optOutDeadline)
    : undefined;
  const courseOptWindowOpen = deadlineDate ? new Date() < deadlineDate : false;

  return useMemo(() => {
    return {
      optWindowOpen: isIA ? courseOptWindowOpen : termOptWindowOpen,
      optDeadline: isIA ? course?.optOutDeadline : termOptDeadline,
    };
  }, [
    isIA,
    courseOptWindowOpen,
    termOptWindowOpen,
    course?.optOutDeadline,
    termOptDeadline,
  ]);
}
